import React from "react";
import { categories } from "../categories";
import { CategoryContainer, CategoryBox, CategoryImage } from "./CategorySelector.styles";

interface CategorySelectorProps {
  selectedCategory: string;
  onSelect: (category: string) => void;
}

export default function CategorySelector({ selectedCategory, onSelect }: CategorySelectorProps) {
  return (
    <CategoryContainer>
      {categories.map((category) => (
        <CategoryBox
          key={category.key}
          onClick={() => onSelect(category.key)}
          isActive={selectedCategory === category.key}
        >
          <CategoryImage src={category.url} />
          {category.label}
        </CategoryBox>
      ))}
    </CategoryContainer>
  );
}
